import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { X, Calendar, Tag, Layers, CheckCircle, Search, TrendingUp } from 'lucide-react';
const CHIP_ICONS = {
    date: _jsx(Calendar, { className: "w-3 h-3" }),
    ontology: _jsx(Tag, { className: "w-3 h-3" }),
    status: _jsx(CheckCircle, { className: "w-3 h-3" }),
    source: _jsx(Layers, { className: "w-3 h-3" }),
    search: _jsx(Search, { className: "w-3 h-3" }),
    relevance: _jsx(TrendingUp, { className: "w-3 h-3" }),
};
const CHIP_COLORS = {
    date: 'bg-blue-50 text-blue-700 border-blue-200',
    ontology: 'bg-purple-50 text-purple-700 border-purple-200',
    status: 'bg-green-50 text-green-700 border-green-200',
    source: 'bg-orange-50 text-orange-700 border-orange-200',
    search: 'bg-gray-50 text-gray-700 border-gray-200',
    relevance: 'bg-teal-50 text-teal-700 border-teal-200',
};
export function FilterChips({ chips, onRemove, onClearAll, showClearAll = true, className = '', }) {
    if (chips.length === 0)
        return null;
    return (_jsxs("div", { className: `flex flex-wrap items-center gap-2 ${className}`, children: [_jsx("span", { className: "text-xs text-gray-500 font-medium", children: "Filtros:" }), chips.map((chip) => (_jsxs("div", { className: `
                        flex items-center gap-1.5 px-2 py-1 rounded-full border text-xs font-medium
                        ${CHIP_COLORS[chip.type]}
                    `, children: [CHIP_ICONS[chip.type], _jsx("span", { className: "max-w-32 truncate", children: chip.label }), _jsx("button", { onClick: () => onRemove(chip.id), className: "p-0.5 hover:bg-black/5 rounded-full transition-colors", title: "Eliminar filtro", children: _jsx(X, { className: "w-3 h-3" }) })] }, chip.id))), showClearAll && chips.length > 1 && onClearAll && (_jsx("button", { onClick: onClearAll, className: "text-xs text-gray-500 hover:text-gray-700 hover:underline px-2 py-1", children: "Limpiar todo" }))] }));
}
export default FilterChips;
